import { vSensors } from '@/utils/sevsors';
import { getValueFromSearchParams, refreshParent } from '@/utils';

// 是否登录
export let isLogin = false
// 是否登录
export let userInfo: any = {}
/**
* @description 修改登录状态
*/
export const changeLoginStatus = (val: boolean) => {
  // 登录状态改变时，刷新父级页面
  if (!isLogin && val) {
    refreshParent()
  }
  isLogin = val
}
/**
* @description 修改用户信息
*/
export const changeUserInfoStatus = (val: any) => {
  userInfo = val
  if (val) {
    val?.userId && vSensors?.sensors?.login(val?.userId);
  }
}

export default () => { 
  
}
